import { prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSellerNumbers = createSelector(getRoot, prop('sellerNumbers'));
export const getIsEditMode = createSelector(getRoot, prop('editMode'));
export const getIsDataSaved = createSelector(getRoot, prop('dataSaved'));
